

var $j = jQuery.noConflict();

$j(document).ready(function() {
    "use strict";
    console.log('load');
});

$j(document).ajaxComplete(function( event,request, settings ) {
    // launch
    console.log('event');
    $j("<p class='details-text'> Les prestations pour photos de portraits et de famille fonctionnent par « thème », c’est à dire par groupes de personnes mises en scène (par exemple votre famille entière parents et enfants).<br />  La prestation pour un thème inclut: mise en scène et prises de vues, mise en ligne d’une galerie privée rassemblant une pré-sélection de vos images et dans laquelle vous choisirez une photo ﬁnale, traitement et retouches de cette photo ﬁnale remise au format 20x30cm sur papier lustré. Un thème supplémentaire serait, ensuite, de ne photographier que vos enfants, donc une nouvelle mise en scène proposée à 55€ en studio et à 65€ en extérieur, incluant les mêmes prestations que pour le premier thème. \n" +
        "\n" +
        "Vous pouvez commander autant de thèmes supplémentaires que vous le voulez. </p>").insertAfter(".booked-appointment-details");
    $j('.field').each(function(i) {
        console.log('load field');
        var $this = $j(this);
        var newClass = "field" + i++;
        $this.addClass(newClass);
    });

});



